export default __webpack_public_path__ + "static/media/download.6502e820.svg";